import styled from 'styled-components/macro'
import { Thread } from 'styles/misc'
import { Section as SectionBase } from 'components/misc'
import { mq } from 'styles/mq'

export const Section = styled(SectionBase)`
  position: relative;
  margin-bottom: 8rem;
  ${mq.medium} {
    margin-bottom: 12rem;
  }
  ${mq.large} {
    margin-bottom: 16rem;
  }
  &::before {
    ${Thread}
    width: 25rem;
    left: 0;
    aspect-ratio: 253 / 1142;
    mask-size: 100% auto;
    mask-image: url("data:image/svg+xml,%3Csvg width='253' height='1142' viewBox='0 0 253 1142' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M-250.93 5.38016C-149.28 -8.11984 -43.2502 13.9202 44.5898 66.8202C132.43 119.72 201.5 203.13 237.1 299.3C245.56 322.14 252.24 346.13 251.41 370.48C250.24 404.93 233.16 438.51 206.01 459.75C178.86 480.99 142.15 489.47 108.44 482.32C101.58 480.86 93.9998 478.05 91.4198 471.53C85.9298 457.62 108.24 448.87 122.23 454.17C148.14 463.99 164.07 494.78 157.09 521.6C152.72 538.41 141.01 552.19 129.48 565.18C99.1398 599.34 66.0998 635.58 60.1198 680.87C50.2298 755.79 128.8 821.5 98.0698 895.45C89.3898 916.34 74.2198 933.78 58.7598 950.29C2.33983 1010.55 -62.3702 1064.41 -137.35 1098.93C-173.08 1115.38 -210.77 1127.28 -247.69 1140.9' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");

    ${mq.ltLarge} {
      display: none;
    }
  }
`
